import {Question} from "domain/entities";

/**
 * Interfaz para las preguntas agrupadas por categoría, dominio y dimensión
 */
export interface GroupedQuestions {
  [category: string]: {
    [domain: string]: {
      [dimension: string]: Question[];
    };
  };
}

/**
 * Agrupa las preguntas por categoría, dominio y dimensión
 * @param questions Lista de preguntas a agrupar
 * @returns Preguntas agrupadas por categoría, dominio y dimensión
 */
export function groupQuestionsByAttributes(questions: Question[]): GroupedQuestions {
  const grouped: GroupedQuestions = {};

  questions.forEach(question => {
    const categoria = question.category || 'Sin Categoría';
    const dominio = question.domain || 'Sin Dominio';
    const dimension = question.dimension || 'Sin Dimensión';

    if (!grouped[categoria]) {
      grouped[categoria] = {};
    }

    if (!grouped[categoria][dominio]) {
      grouped[categoria][dominio] = {};
    }

    if (!grouped[categoria][dominio][dimension]) {
      grouped[categoria][dominio][dimension] = [];
    }

    grouped[categoria][dominio][dimension].push(question);
  });

  return grouped;
}
